var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{style:({marginLeft: '5px'}),on:{"click":_vm.addGroup}},[_c('a-icon',{attrs:{"type":"usergroup-add"}}),_vm._v(" Добавить список\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }